import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MonitoredTrain } from '../../models/monitored-train';
import { FaultMonitoringDataService } from '../../services/fault-monitoring-data.service';
import { StateService } from '@uirouter/core';

import { MonitoringBehaviorSubjectService } from '../../services/monitoring-behavior-subject.service';
import { Observable, interval, BehaviorSubject, Subscription, merge, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ReferenceArea } from '../../../reference-areas/models/reference-area';
import { ReferenceAreaDataService } from '../../../reference-areas/services/reference-area-data.service';

@Component({
  selector: 'app-monitoring-overview',
  template: require('./monitoring-overview.component.html'),
  styles: [require('./monitoring-overview.component.sass')]
})
export class MonitoringOverviewComponent implements OnInit, OnDestroy {
  
  monitoredTrains$: Observable<MonitoredTrain[] | null>;
  projectId: number;
  usedFields = 'trainId, projectId, currentPosition, projectName, officialId, messageInfo, speed, heading, users, totalUploadRateKbit, totalDownloadRateKbit, timestamp';

  referenceAreas$: Observable<ReferenceArea[]>;
  
  private readonly refreshMonitoredTrainList$ = new BehaviorSubject(undefined);
  private readonly refreshReferenceAreas$ = new BehaviorSubject(undefined);
  monitoringDataSubscription: Subscription;

  constructor(
    @Inject('MonitoringStoreService') private monitoringStoreService: any,
    public $state: StateService,
    private faultMonitoringDataService: FaultMonitoringDataService,
    private monitoringBehaviorSubjectService: MonitoringBehaviorSubjectService,
    private referenceAreaDataService: ReferenceAreaDataService,
  ) { 
    this.projectId = this.$state.params && this.$state.params.projectId;
    this.referenceAreas$ = this.refreshReferenceAreas$.pipe(
      switchMap(() =>this.referenceAreaDataService.getReferenceAreas(this.projectId))); 
   
    this.monitoredTrains$ = merge(this.refreshMonitoredTrainList$, interval(environment.config.monitoring.refreshPeriod * 1000)).pipe(
      switchMap(() =>this.faultMonitoringDataService.getAllTrains(this.projectId)))

    this.monitoringDataSubscription = this.monitoringBehaviorSubjectService.changeOccured.subscribe((data) => {
      if (data) {
        switch (data.action) {
          case 'trains-updated':
              this.refreshMonitoredTrainList$.next(undefined);
            break;
        }
      }
    })
    
  }

  ngOnInit(): void {
    this.reload();
  }

  reload = () => {
    this.refreshMonitoredTrainList$.next(undefined);
    this.refreshReferenceAreas$.next(undefined);
  }

  investigateTrain = (train: MonitoredTrain) => {
    this.$state.go('monitoring-detail', {
      projectId: train.projectId, 
      trainId: train.trainId
    });
  }

  ngOnDestroy(): void {
    this.monitoringDataSubscription.unsubscribe();
  }

}
